import { Component, Input } from '@angular/core';
import { RootService } from 'src/app/shared/services/root.service';
import { CultureService } from 'src/app/shared/culture/culture.service';

@Component({
    selector: 'app-block-banner',
    templateUrl: './block-banner.component.html',
    styleUrls: ['./block-banner.component.scss']
})
export class BlockBannerComponent {
    @Input() img:string = 'assets/images/banners/autumn-sale.webp';
    @Input() url:string = '/products/sale';
    @Input() title:string = this.culture.t('primehat-banner-title', 'Top-Quality Home, Lifestyle, Toy Products & Gadgets at Best Price with Delivery Across Bangladesh');
    constructor(public root:RootService, private culture: CultureService) { }
}
